import { PluginRegistry } from "./PluginRegistry";
export var getPluginRegistry = function () {
    var _a;
    return (_a = (window.platformPluginRegistry)) !== null && _a !== void 0 ? _a : PluginRegistry.getInstance();
};
